import { connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { persistStore } from 'redux-persist';

import rootEpic from '../Middleware/Epic/rootEpic';
import rootReducer from '../Redux/Reducers/rootReducer';
import history from './history';

// create an instance of the redux-observable middleware//

const epicMiddleware = createEpicMiddleware();

function configureStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    connectRouter(history)(rootReducer),
    {},
    composeEnhancers(applyMiddleware(epicMiddleware, routerMiddleware(history))),
  );
  epicMiddleware.run(rootEpic);
  return store;
}

export const store = configureStore();

export const persistor = persistStore(store);

export default { store, persistor };
